/* BUTTON IN THE NAVIGATIONO BAR */
import React from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { theme } from "../theme";

const fontFamilies = {
	roboto: "Roboto",
	robotoCondensed: "Roboto Condensed",
	montserrat: "Montserrat, sans-serif !important",
};

const fontWeights = {
	regular: "fontWeightRegular",
	medium: "fontWeightMedium",
	bold: "fontWeightBold",
};

const variants = {
	pageTitle: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "1.75rem",
		color: theme.colors.mainGreen.secondary,
	},
	headerButton: {
		fontFamily: fontFamilies.roboto,
		color: theme.colors.mainGreen.main,
		fontWeight: fontWeights.bold,
		fontSize: "1.80rem",
		color: theme.colors.mainGreen.secondary,
	},
	h1: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1.75rem",
		color: theme.colors.mainGreen.secondary,
	},
	h2: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1.3125rem",
		color: theme.colors.mainGreen.secondary,
	},
	h3: {
		fontFamily: fontFamilies.robotoCondensed,
		fontWeight: fontWeights.bold,
		fontSize: "1.125rem",
		color: theme.colors.mainGreen.secondary,
	},
	h4: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1.125rem",
		color: theme.colors.mainGreen.secondary,
	},
	h4Regular: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "1.125rem",
		color: theme.colors.mainGreen.secondary,
	},
	h5: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "0.875rem",
		color: theme.colors.mainGreen.secondary,
	},
	h5Regular: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "0.875rem",
		color: theme.colors.mainGreen.secondary,
	},
	h6: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "0.875rem",
		color: theme.colors.mainGreen.secondary,
	},
	h6BoldWhite: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "0.95rem",
		color: theme.colors.mainGreen.secondary,
	},
	text: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "0.975rem",
		color: theme.colors.mainGreen.secondary,
	},
	formText: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "1.175rem",
		color: "black",
	},
	textPrint: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1rem",
		color: "#000",
	},
	textWhite: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "0.875rem",
		color: "white",
	},
	textWhiteArchived: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "0.7rem",
		color: "white",
		lineHeight: 1,
	},
	inputError: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		color: "#FF0000",
		fontSize: "0.975rem",
	},
	columnHeader: {
		fontFamily: fontFamilies.robotoCondensed,
		fontWeight: fontWeights.bold,
		fontSize: "0.875rem",
	},
	cardHeader: {
		fontFamily: fontFamilies.robotoCondensed,
		fontWeight: fontWeights.bold,
		fontSize: "1.125rem",
	},
	cardContent: {
		fontFamily: fontFamilies.robotoCondensed,
		fontWeight: fontWeights.regular,
		fontSize: "1.125rem",
	},
	formError: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "0.875rem",
		color: "red",
		marginTop: 0,
	},
	feRegistrationTitle: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "2.5rem",
		marginTop: 0,
	},
	textButton: {
		cursor: "pointer",
		color: "white",
	},
	h1PageTitle: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1.75rem",
		color: theme.colors.mainGreen.secondary,
	},
	h1PageTitleDialog: {
		fontFamily: fontFamilies.montserrat,
		fontWeight: fontWeights.medium,
		fontSize: "1.65rem",
		color: theme.colors.mainGreen.main,
	},
	iconButtonVariant: {
		fontFamily: fontFamilies.montserrat,
		fontWeight: fontWeights.bold,
		color: "#FFF",
		fontSize: 14,
	},
	h1PageSubtitle: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1.15rem",
		color: theme.colors.mainGreen.secondary,
	},
	h1PageSubtitleColored: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1.15rem",
		color: theme.colors.mainGreen.secondary,
	},
	h1PageTableHeadColored: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1.15rem",
		color: theme.colors.primary.white,
	},
	h1PageTableHead: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1.15rem",
		color: theme.colors.primary.white,
	},
	h4ComponentLabel: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1rem",
		color: "#FFF",
	},
	h4ComponentLabelCardTitle: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "0.8rem",
		color: "#FFF",
	},
	h6ComponentLabelCardSubtitle: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "0.7rem",
		color: "#FFF",
	},
	h4ComponentLabelRegular: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "1rem",
		color: "#FFF",
	},
	h4ComponentLabelPrint: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "0.875rem",
		color: "#000",
	},
	h4ComponentLabelColored: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1rem",
		color: "#31ccad",
	},
	h4ComponentLabelError: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1rem",
		color: "#FF0000",
	},
	h5ComponentLabelErrorRegular: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "0.875rem",
		color: "#FF0000",
	},
	h4ComponentLabelCenter: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1rem",
		color: "#FFF",
		textAlign: "center",
	},
	listHeader: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1rem",
		color: "#31ccad",
	},
	listHeaderCenter: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1rem",
		color: "#31ccad",
		textAlign: "center",
	},
	checkListLabel: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1rem",
		color: "#31ccad",
		paddingLeft: "0.5rem",
	},
	selectItem: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "1rem",
		color: "black",
		"&:selected": {
			color: "white",
		},
		"&:focused": {
			color: "black",
		},
	},
	tableText: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "1.2rem",
		color: "black",
	},
	monthYearCalendar: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.regular,
		fontSize: "24px",
		color: "white",
	},
	breadcrumbs: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1.45rem",
		color: theme.colors.mainGreen.main,
	},
	breadcrumbsSelected: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1.45rem",
		color: theme.colors.mainGreen.main,
	},
	detailStationTitle: {
		fontFamily: fontFamilies.roboto,
		fontSize: "1.75rem",
		color: theme.colors.mainGreen.secondary,
	},
	detailStationSubtitle: {
		fontFamily: fontFamilies.roboto,
		fontWeight: fontWeights.bold,
		fontSize: "1.3125rem",
		color: theme.colors.mainGreen.secondary,
	},
	inputLabel: {
		fontFamily: fontFamilies.roboto,
		marginBottom: 5,
		paddingBottom: 0,
		color: "black",
		fontSize: 15,
	},
	dialogRentDetail: {
		fontFamily: fontFamilies.roboto,
		marginBottom: 5,
		paddingBottom: 0,
		color: "black",
		fontSize: 15,
	},
	dialogReservationDetailTitle: {
		fontFamily: fontFamilies.roboto,
		color: theme.colors.mainGreen.main,
		fontSize: 15,
		fontWeight: "bold",
	},
	dialogReservationDetailValue: {
		fontFamily: fontFamilies.roboto,
		marginBottom: 5,
		paddingBottom: 0,
		fontSize: 12,
		color: theme.colors.mainGreen.main,
	},
};

const ellipsisStyle = {
	whiteSpace: "nowrap",
	overflow: "hidden",
	textOverflow: "ellipsis",
};

const SpText = ({ isIconButton, variant, textAlign, children, color, style, margin = 1, ellipsis, ...rest }) => (
	<Typography {...rest} component='div' style={{ ...style, ...variants[variant] }}>
		<Box textAlign={(textAlign = textAlign ? textAlign : "left")} {...variants[isIconButton ? "iconButtonVariant" : variant]} style={ellipsis && ellipsisStyle}>
			{children}
		</Box>
	</Typography>
);

export default SpText;
